import type { OnboardingStep } from './step';

/** Steps that show the 4-segment wizard progress bar. */
const WIZARD_STEPS: OnboardingStep[] = ['outcome', 'digital-setup', 'priority', 'recommendation'];

type WizardProgress = { index: number; total: number };

/** The 1-based progress position for a wizard step, or null for a non-wizard step. */
export const getWizardProgress = (step: OnboardingStep): WizardProgress | null => {
  const idx = WIZARD_STEPS.indexOf(step);
  if (idx === -1) {
    return null;
  }
  return { index: idx + 1, total: WIZARD_STEPS.length };
};
